import { useContext, useMemo } from 'react';
import { SebastianStatus } from '~/constants/common/SebastianStatus';
import Section from '~/constants/vdp/section';
import SebastianContext, {
  useSebastianStatus
} from '~/context/common/SebastianContext';
import { useIsCampaignTemplateOne } from '~/context/vdp/StaticContext';

export default function useSebastianQuestions(
  section: Section.WhyBuy | Section.OwnerReviews | Section.PriceDetails
) {
  const {
    questions: { data, isLoaded, hasError }
  } = useContext(SebastianContext);
  const isCampaignTemplateOne = useIsCampaignTemplateOne();
  const sebastianStatus = useSebastianStatus();

  const filteredQuestions = useMemo(
    () => data.questions.filter(question => question.section === section),
    [data, section]
  );

  const sectionHasQuestions = filteredQuestions.length > 0;
  const showSection = useMemo(
    () =>
      !isCampaignTemplateOne &&
      sebastianStatus !== SebastianStatus.Error &&
      !hasError &&
      !(isLoaded && !sectionHasQuestions),
    [
      hasError,
      isCampaignTemplateOne,
      isLoaded,
      sebastianStatus,
      sectionHasQuestions
    ]
  );

  return {
    isLoaded,
    questions: filteredQuestions,
    showSection
  };
}
